/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.1.0
 * @since 1.1.0
 */

import styled from 'styled-components';

import { ILayoutProps, LayoutStyled } from './Layout';

export interface IFlex {
    alignContent?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly' | 'stretch';
    alignItems?: 'stretch' | 'flex-start' | 'flex-end' | 'center' | 'baseline' | 'start' | 'end';
    flexGrow?: number;
    flexShrink?: number;
    flexWrap?: 'no-wrap' | 'wrap' | 'wrap-reverse';
    justifyContent?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly';
}

export const FlexStyled = styled(LayoutStyled)<ILayoutProps & IFlex>`
    align-items: ${props => props.alignItems};
    align-content: ${props => props.alignContent};
    flex-grow: ${props => props.flexGrow};
    flex-shrink: ${props => props.flexShrink};
    flex-wrap: ${props => props.flexWrap};
    justify-content: ${props => props.justifyContent};
    display: flex;
`;

export const FlexColumnStyled = styled(FlexStyled)`
    flex-direction: column;
`;

export const FlexMiddleStyled = styled(FlexStyled)`
    align-items: center;
    justify-content: center;
`;

export const FlexColumnMiddleStyled = styled(FlexMiddleStyled)`
    flex-basis: 100%;
    flex-grow: 1;
    flex-direction: column;
`;
